import _ from 'underscore';
import Backbone from 'backbone';
import $ from 'jquery';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
import { getODataErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import EditorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/editor';
import InlineErrorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/inline-error';
import template from '@bingads-webui-campaign-legacy/editorial-appeal/template/bulk.pug';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import {processRejectReasonsFromOdata} from '../utilities';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/editorial-appeal');
const i18nGlobal = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

const alertHelper = new AlertHelper({ i18nGlobal });

export default class SingleAppealView extends Backbone.View {
  initialize({
    id,
    parentId,
    grid,
    controller,
    submit,
    appealTitle,
    infoMsg,
    permissions,
  }) {
    this.id = id;
    this.parentId = parentId;
    this.grid = grid;
    this.controller = controller;
    this.submit = submit;
    this.appealTitle = appealTitle;
    this.infoMsg = infoMsg;

    this.editor = null;
    this.inlineErrorView = null;
    this.permissions = permissions;
  }

  render() {
    this.$el.html(template({ i18n }));
    this.hide(false);
    $(window).scrollTop(this.$('.editor').scrollTop());
    this.getAppealRejections();
    return this;
  }

  getAppealRejections() {
    const url = 'Advertiser/Customers()/Accounts()/Ads/Default.EditorialReasons';

    odata.post(url, {
      EntityIdsParentIds: [{ EntityId: this.id, ParentId: this.parentId }],
    }).then((data) => {
      if (data && !data.Errors) {
        const processedData = processRejectReasonsFromOdata(data, this.controller, this.permissions);

        this.onFetchBulkAppealRejections(processedData);
      } else {
        if (!this.inlineErrorView) {
          this.inlineErrorView = new InlineErrorView({ rowId: 'bulk', useKwCss: true }).render();
          this.$('.editor').append(this.inlineErrorView.$el);
        }

        this.inlineErrorView.removeCancel();

        this.$('.appeal').hide();
        this.$('.cancel').unbind('click').click(() => {
          this.hide();
        });
        this.$('form.bulk-appeal').show();
        $('#bulkCancelButton').focus();
      }
    })
      .catch(() => {
        if (!this.inlineErrorView) {
          this.inlineErrorView = new InlineErrorView({ rowId: 'bulk', useKwCss: true }).render();
          this.$('.editor').append(this.inlineErrorView.$el);
        }

        this.inlineErrorView.removeCancel();

        this.$('.appeal').hide();
        this.$('.cancel').unbind('click').click(() => {
          this.hide();
        });
        this.$('form.bulk-appeal').show();
        $('#bulkCancelButton').focus();
      });
  }

  hide(showToolbar = true) {
    if (this.editor) {
      this.editor.remove();
      this.editor = null;
    }

    this.$('form.bulk-appeal').hide();

    if (showToolbar) {
      this.grid.grid.toolbar.gridToolbarGroup.showAllToolbars();
    }
  }

  disableButtons() {
    this.$('.appeal, .cancel').attr('disabled', 'disabled');
  }

  onAppeal = _.debounce((appealIds) => {
    const  isValid = this.editor && this.editor.viewModel.validate();

    if (isValid) {
      const appealJson = this.editor.getAppealData();
      const odataUrl = 'Advertiser/Customers()/Accounts()/Ads/Default.CreateAppeals';

      odata.post(odataUrl, {
        'EntityIds': appealIds,
        JustificationText: appealJson.Justification,
      }).then(() => {
        this.hide();
        dataContextManager.updateContext(['AdGrid']);
        this.grid.grid.showAdStrength.refreshAdItem();
        this.grid.view.refresh(true);
      })
        .catch((response) => {
          const errorMessages = _.pluck(getODataErrors(response.errors), 'message');

          if (!_.isEmpty(errorMessages)) {
            alertHelper.showAlert(errorMessages.join(';\n'));
          }
        });
    }
  });


  onFetchBulkAppealRejections({ appealIds = [], appealData: [firstAppealData = {}]}) {
    if (firstAppealData.IsAppealable) {
      this.$('form.bulk-appeal').show();

      this.editor = new EditorView({
        appealData: firstAppealData,
        controlId: 'bulkAppeal',
        appealTitle: this.appealTitle,
        infoMsg: this.infoMsg,
        hideAppealCheckBox: true,
        el: this.$('.editor')[0],
        isForVNext: true,
      }).render();

      this.$('.cancel').unbind('click').click(() => {
        this.hide();
      });

      this.editor.toBulk(appealIds);

      if (_.isEmpty(appealIds)) {
        this.$('.appeal').removeClass('button-highlighted').hide();
        this.$('.cancel').addClass('button-highlighted');
      } else {
        this.$('.appeal').addClass('button-highlighted').show();
        this.$('.cancel').removeClass('button-highlighted');
      }

      this.$('.appeal').unbind('click').click(_.partial(this.onAppeal, appealIds));
    }
  }


}
